import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 790,
    borderRadius: 4,
    backgroundColor: '#FFFFFF'
  },

  dialogStyle: {
    borderRadius: '12px !important',
    maxWidth: '44%',
    maxHeight: "100%",
    backgroundColor: 'transparent',
    overflowY: 'hidden',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%'
    }
  },

  iconContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  title: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: '2em',
    fontWeight: "400",
    textAlign: 'center',
    margin: 16,
  },

  cardBody: {
    width: '100%',
    alignItems: 'center',
    padding: '20px 3em 18px 5em',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },

  statusBody: {
    color: "rgba(0,0,0,0.87)",
    fontFamily: "Montserrat",
    fontSize: '2em',
    fontWeight: "bold",
  },

  bodyText: {
    color: "#0C0B0B",
    fontFamily: "Montserrat",
    fontSize: '1.4em',
    marginBottom: 30,
    marginTop: 0,
  },

  linkStyle: {
    color: "#25ABC7",
    fontFamily: "Montserrat",
    fontSize: '1.2em',
    fontWeight: "600",
    marginTop: 5,
  },

  btn: {
    width: 188,
    fontFamily: "Montserrat",
    fontSize: '1.5em',
    fontWeight: "600",
  },

  flexBox: {
    display: 'flex',
    alignItems: 'center',
  },
 
  statusTitle: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 28,
    fontWeight: "700",
    marginBottom: 20,
    marginTop: 0,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 24
    },
  },

  statusSubTitle: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "400",
    marginBottom: 26,
    marginTop: 28
  },

  paragraph: {
    color: "#202020",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "500",
    marginBottom: 12,
    marginTop: 0,
    textAlign: 'center',
    marginTop: 10
  },

  signInBtn: {
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: '600',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      width: 180
    },
  },

  buttonContainer: {
    textAlign: 'center'
  },

  closeIcon: {
    position: 'absolute',
    right: 2
  },

  img: {
    width: '286px',
    height: '387px',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
  }
}));
